import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getAppImage,
  getAppQuestions,
  createApp,
  getApp,
  updateApp,
  resetEditApp,
  getApps,
  deleteApp,
  annulError,
  deleteApplication,
} from '../../reducers/create-app/duck';
import { updateProfileStatus } from '../../reducers/user/duck';
import { logout } from '../../reducers/oauth/duck';
import CreateApp from './CreateApp';

const mapStateToProps = ({
  createAppStore: {
    appImageStatus,
    appImage,
    appQuestions,
    appQuestionsStatus,
    appImageError,
    createAppStatus,
    createAppError,
    currentEditableApp,
    updateAppStatus,
    createdAppId,
    deleteAppStatus,
    deleteAppError,
    deleteAppSuccess,
  },
  userStore: {
    profileStepStatus,
  },
  oauthStore: {
    userToken: { accessToken },
  },
}) => ({
  appImageStatus,
  appImage,
  appQuestions,
  appImageError,
  appQuestionsStatus,
  createAppStatus,
  createAppError,
  profileStepStatus,
  currentEditableApp,
  updateAppStatus,
  createdAppId,
  accessToken,
  deleteAppStatus,
  deleteAppError,
  deleteAppSuccess,
});

const mapDispatchToProps = {
  getAppImage,
  getAppQuestions,
  createApp,
  updateProfileStatus,
  logout,
  deleteApp,
  getApp,
  resetEditApp,
  annulError,
  getApps,
  updateApp,
  deleteApplication,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateApp));



// WEBPACK FOOTER //
// ./src/containers/CreateApp/index.js